import './App.css';
import Logs from './Logs';
import AccPage from './AccPage';
import React, {useState, useEffect} from 'react';

function App() {
  var userdata = localStorage.getItem('usermail');
  const [tt, setTt] = useState('')
  const cc = () => {
    setTt(false)
  }
  return (
    <div className="app" >
        { 
          !userdata || tt? <Logs click={cc}/> : 
          <AccPage
            userdata = {userdata}
          />
        }
        
    </div>
  );
}

export default App;
/*
        
*/